// App.js
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastProvider } from './components/Toast';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import DashboardLayout from './components/Layout/DashboardLayout';
import Dashboard from './pages/Dashboard/Dashboard';
import Appointments from './pages/Dashboard/Appointments';
import Billing from './pages/Dashboard/Billing';
import Clients from './pages/Dashboard/Clients';
import Staff from './pages/Dashboard/Staff';
import Services from './pages/Dashboard/Services';
import Settings from './pages/Dashboard/Settings';
import VerifyEmail from './pages/Auth/VerifyEmail';

import Invoices from './pages/Dashboard/Invoices';
import InvoiceView from './pages/Dashboard/InvoiceView';
import Attendance from './pages/Dashboard/Attendance';
import Salary from './pages/Dashboard/Salary';
import Finance from './pages/Dashboard/Finance';
 
function App() {
  return (
    <ToastProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="appointments" element={<Appointments />} />
            <Route path="billing" element={<Billing />} />
            <Route path="billing/:uuid" element={<Billing />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="invoice/:uuid" element={<InvoiceView />} />
            <Route path="clients" element={<Clients />} />
            <Route path="staff" element={<Staff />} />
            <Route path="services" element={<Services />} />
            <Route path="settings" element={<Settings />} />

            <Route path="attendance" element={<Attendance />} />
            <Route path="salary" element={<Salary />} />
            <Route path="finance" element={<Finance />} />
          </Route>
        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;